import React, { useContext, useEffect, useState } from 'react';
import { connect } from "react-redux"
import { Icon, Message, Grid } from 'semantic-ui-react';
import GlobalContext from '../../contexts/GlobalContext';
import Utility from '../../Utility';
import API, { ResponseManagement, ErrorManagement } from '../../API';
import Page from '../../components/Page/Page';
import Box from '../../components/Box/Box';
import 'react-circular-progressbar/dist/styles.css';
// import imageDefault from './../../assets/cardDashboardNoPhoto.png';
import ViewBooking from '../../components/Widgets/ViewBooking/ViewBooking';
import Chat from '../../components/Widgets/Chat/Chat';
import AddBooking from '../../components/Widgets/AddBooking/AddBooking';
import Booking from '../../components/Widgets/Booking/Booking';
import Establishment from '../../components/Widgets/Establishment/Establishment';
import CheckinBooking from '../../components/Widgets/CheckinBooking/CheckinBooking';
//import BankCardsListWidgetCard from '../../components/Widgets/BankCardsListWidgetCard/BankCardsListWidgetCard';
import EvalBooking from '../../components/Widgets/EvalBooking/EvalBooking';

import Auth from './../../Auth';

const Dashboard = props => {

  const [globalContext, dispatch] = useContext(GlobalContext);
  const [errorMsgState] = useState("");
  const [importantMessageState, setImportantMessageState] = useState({});
  const [bookingState, setBookingState] = useState({});
  const [completionRateState, setCompletionRateState] = useState(false);
  const [opinionMessageState, setOpinionMessageState] = useState("");
  const [displayDashboardState, setDisplayDashboardState] = useState(false);
  const [imageCardState, setImageCardState] = useState('');
  const [cardDashboardState, setCardDashboardState] = useState([]);
  //const [cardAddBookingCustomLinkState, setCardAddBookingCustomLinkState] = useState('');
  const [messagesState, setMessagesState] = useState([]);

  useEffect(() => {
    dispatch({ type: 'SET_HEADERS', payload: Utility.getHeaderPage('dashboard', globalContext.translations) });
    let dataToSend = {
      displayControl: globalContext.displayControl
    }
    API.post(Utility.getUrlAjax() + '/dashboard', JSON.stringify(dataToSend)).then(response => {
      ResponseManagement(response,
        () => {

          if (response.data.data.currentBookingFolder !== false) {
            /*props.loadBankCards({
              bookingFolderId: response.data.data.currentBookingFolder.id,
              active: "1",
              virtualCard: false
            });*/

            setBookingState(response.data.data.currentBookingFolder);
            setImageCardState(Utility.imageExists(response.data.data.currentBookingFolder.photo, 'cardDashboard'));
          } else {
            setBookingState(false);
          }

          if (response.data.data.completionRate !== false) {
            setCompletionRateState(response.data.data.completionRate);
          } else {
            setCompletionRateState(false);
          }

          if (response.data.data.importantMessage !== false) {
            setImportantMessageState(response.data.data.importantMessage);
          }
          setOpinionMessageState(globalContext.translations.voteMessage);

          if (response.data.data.cardDashboard !== undefined && response.data.data.cardDashboard !== null && response.data.data.cardDashboard.length > 0){
            const cardDashboard = response.data.data.cardDashboard;
            // setCardDashboardState(cardDashboard);
            setCardDashboardState(response.data.data.cardDashboard);

            /*if( response.data.data?.CustomLinkBe ){
              setCardAddBookingCustomLinkState( response.data.data?.CustomLinkBe );
            }*/
            

          }

          if (response.data.data.bookingFolderMessages !== undefined && response.data.data.bookingFolderMessages !== null && response.data.data.bookingFolderMessages.length > 0){
            setMessagesState(response.data.data.bookingFolderMessages);
          }

          setDisplayDashboardState(true);
        },
        () => { }
      );
    }).catch(error => {
      //console.error(error);
      ErrorManagement(error, () => { });
    });
  }, [globalContext.translations])// eslint-disable-line react-hooks/exhaustive-deps

  const getMessageImportant = () => {
    let message = null;

    if (importantMessageState !== false) {
      const styleMessage = {
        info: false,
        warning: false,
        success: false,
        error: false,
      };
      let icon = null;
      switch (importantMessageState.style) {
        case 'callout-success':
          styleMessage.success = true;
          icon = <Icon name="check" color="green" size="tiny" />;
          break;
        case 'callout-warning':
          styleMessage.warning = true;
          icon = <Icon name="warning sign" color="yellow" size="tiny" />;
          break;
        case 'callout-danger':
          styleMessage.error = true;
          icon = <Icon name="warning sign" color="red" size="tiny" />;
          break;
        default:
          styleMessage.info = true;
          icon = <Icon name="info" color="blue" size="tiny" />;
          break;
      }
      
      message =  (
        <div className="mt-4 d-flex justify-content-center">
          <Message style={{ width: '89.6%' }} 
            icon
            info={styleMessage.info}
            warning={styleMessage.warning}
            success={styleMessage.success}
            error={styleMessage.error}
            >
            {icon}
            <Message.Content>
              <Message.Header>{importantMessageState.title}</Message.Header>
              {(importantMessageState.message) ? importantMessageState.message : null}
            </Message.Content>
          </Message>
        </div>
      );
    }
    return importantMessageState.message ? message : null;
  }

  const getCard = (typeCard, key) => {
    let dataReturn = null;

    switch (typeCard) {
      case 'establishment':
        dataReturn = <Establishment setActiveItemMenu={props.setActiveItemMenu}/>;
        break;
      case 'booking':
        if (bookingState) {
          dataReturn = <Booking booking={bookingState} image={imageCardState} setActiveItemMenu={props.setActiveItemMenu}/>;
        }
        break;
      case 'completionRate':
      case 'checkinBooking':
        if( globalContext.displayControl.earlyCheckInForm ){
      
          if (completionRateState && bookingState) {
            dataReturn = <CheckinBooking booking={bookingState} completionRate={completionRateState} setActiveItemMenu={props.setActiveItemMenu}/>
          }
          else{
            dataReturn = null;
          }
        }
        else{
          dataReturn = null;
        }
        break;
      case 'voteMessage':
      case 'viewBooking':
        dataReturn = <ViewBooking message={opinionMessageState} setActiveItemMenu={props.setActiveItemMenu}/>;
        break;
      case 'addBooking':
        if (globalContext.establishment.bookingEngineId !== false) {
          dataReturn = <AddBooking setActiveItemMenu={props.setActiveItemMenu} />;
        }
        break;
        //desactive le temps de finir le dev
      // case 'evalBooking':
      //     dataReturn = <EvalBooking booking={bookingState} setActiveItemMenu={props.setActiveItemMenu}/>;
      //   break;
      case 'chat':
        // // SI MESSAGERIE ACTIVEE
         if( globalContext.displayControl.messaging ){
          dataReturn = <Chat folderId={bookingState.id} messages={messagesState} />;
         }
         else{
           dataReturn = null;
         }
        break;
      /*case 'bankCards':
        if (props.isActivatedBank === true) dataReturn = <BankCardsListWidgetCard setActiveItemMenu={props.setActiveItemMenu} booking={bookingState} />;
        break;*/
      default:
        dataReturn = null;
        break;
    }

    if (dataReturn !== null) {
      dataReturn = <Grid.Column key={key} className="mb-5" computer={5} tablet={8} mobile={16}>{dataReturn}</Grid.Column>;
    }

    return dataReturn;
  }


  /**
   * Retourne Bloc HTML de Component React de carte pour le Dashboard
   * @returns Array listWidgets
   */
  const getContent = () => {
    const listWidgets = [];
    if (cardDashboardState.length == 0){
      setCardDashboardState( ['booking','addBooking'] );
    }

    let key = 0;
      for (let typeCard of cardDashboardState) {// eslint-disable-line no-unused-vars
        listWidgets.push(getCard(typeCard, key));
        key++;
      }

    const errors = (
      <Message negative>
        <Message.Header>Erreur</Message.Header>
        <p>{errorMsgState}</p>
      </Message>
    );

    const body = (
      <div>
        <Grid className="mb-5 mt-5" style={{ height: '100%' }} columns="3">
          <Grid.Row centered>
            {listWidgets}
          </Grid.Row>
        </Grid>
      </div>
    );



    return errorMsgState === "" ? body : errors
  }

  return (
    <Page paramDisplay={displayDashboardState} location={props.location} history={props.history}>
      <Box header="" message={getMessageImportant()}>
        {getContent()}
      </Box>
    </Page>
  )
}

/*const mapProps = state => ({
  isActivatedBank: state.bank.isActivated
})

const mapDispatch = (dispatch) => ({
  loadBankCards: dispatch.bank.load
})*/

//export default connect(mapProps, mapDispatch)(Dashboard);
export default Dashboard;